import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { avviaOsservabilita } from './osservabilita'

// Prima di createRoot: un errore in fase di montaggio e' proprio quello che
// serve vedere, e dopo il render sarebbe gia' troppo tardi per catturarlo.
avviaOsservabilita(import.meta.env)

const radice = document.getElementById('root')
if (!radice) throw new Error('elemento #root assente in index.html')

createRoot(radice).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
